<template>
  <div>
    <div class='coursework-viewer__comment'>
      <div class='coursework-viewer__comment_image'>
        <div class='coursework-viewer__comment_user-avatar'>
          <img :src="comment_thread.user.avatar.thumb.url" v-tooltip="userInfoTooltipParams(comment_thread.student_data)">
        </div>
      </div>

      <div class='coursework-viewer__comment_main'>
        <div class='coursework-viewer__comment_header'>
          <div class='coursework-viewer__comment_user-name'>
            <span class='truncate' v-tooltip="userInfoTooltipParams(comment_thread.student_data)">{{ comment_thread.user.full_name }}</span>
          </div>
          <div class='coursework-viewer__comment_time'>{{ comment_thread.time_formatted }}</div>
        </div>
        <template v-if="!editing || mobile_view">
          <div class='coursework-viewer__comment_post' v-html="comment_thread.content"></div>

          <a href="javascript:" class='coursework-viewer__comment_likes inline-block-link' @click="like" :class="{'is-selected': comment_thread.favorited}" :tabindex="is_open ? '' : '-1'">
            <span>{{ comment_thread.favorited ? 'Unlike' : 'Like' }}</span>
            <i class='coursework-viewer__comment_like-heart'></i>
            <span>{{ comment_thread.favorite_count }}</span>
          </a>
          <i class='coursework-viewer__comment_bullet'></i>
          <a href="javascript:" class='coursework-viewer__comment_reply inline-block-link' @click="reply" :tabindex="is_open ? '' : '-1'">Reply</a>
          <template v-if="comment_thread.allowed_to_edit || comment_thread.viewing_by_instructor">
            <i class='coursework-viewer__comment_bullet'></i>
            <a href="javascript:" class='coursework-viewer__comment_reply inline-block-link' @click="edit" :tabindex="is_open ? '' : '-1'">Edit</a>
            <i class='coursework-viewer__comment_bullet'></i>
            <a href="javascript:" class='coursework-viewer__comment_reply inline-block-link' @click="remove" :tabindex="is_open ? '' : '-1'">Delete</a>
          </template>
        </template>
        <template v-if="editing">
          <comment-modal v-if="mobile_view" :current_user="current_user" :value="comment_thread.content" @persist="update" @cancel="editing = false"/>
          <comment-editor v-else="true" :value="comment_thread.content" @persist="update" @cancel="editing = false" class="mt1 p0" :class="{'is-open': editing}"/>
        </template>
      </div>
    </div>

    <div class='comment__replies pl1 pr1' v-if="threadComments.length > 0 || show_replies" :class="{'comment__replies--hidden': !show_replies}">
      <div class='comment__replies-header border-bottom'>
        <a href="javascript:" class='comment__replies-count inline-block-link' @click="toggleReplies">
          <i class='svg-icon-sm icon-caret'></i>
          <template v-if="threadComments.length > 0">
            {{ `${threadComments.length} ${'reply'.pluralize(threadComments.length, 'replies')}` }}
          </template>
        </a>
        <div class='comment__replies-form' v-if="replying">
          <comment-modal v-if="mobile_view" :current_user="current_user" @persist="create" @cancel="replying = show_replies = false"/>
          <comment-editor v-else="true" @persist="create" @cancel="replying = show_replies = false" :class="{'is-open': replying}" class="mt1 p0"/>
        </div>
      </div>
      <div class='comment__replies-comments'>
        <comment-thread v-for="comment in threadComments" :current_user="current_user" :mobile_view="mobile_view" :is_open="is_open"
                        :comment_thread="comment" :comments_path="comments_path" :key="comment.id"/>
      </div>
    </div>
  </div>
</template>

<script>
  import commentEditor from './comment-editor.vue'
  import commentModal from './comment-modal.vue'
  import LoginModal from './../../login-modal';
  export default {
    name: 'comment-thread',
    props: {
      current_user: Object,
      mobile_view: Boolean,
      comment_thread: Object,
      comments_path: String,
      is_open: Boolean
    },
    data() {
      return {
        editing: false,
        replying: false,
        show_replies: false
      }
    },
    components: {
      commentEditor,
      commentModal
    },
    computed: {
      threadComments() {
        return _.filter(this.comment_thread.thread_comments, function(comment) { return !comment.deleted; })
      }
    },
    methods: {
      loginOrRegister() {
        //TODO: Set avatar
        let deferred = $.Deferred();
        if (this.current_user.status === 'public') {
          let $el = $('#js-course-enroll-modal--authenticate');
          let args = {
            onLogin: (response) => {
              this.current_user.status = 'member';
              deferred.resolve();
              $el.modal('hide');
            },
            onRegister: (response) => {
              Kadenze.Analytics.track('student_ui', 'enrollment_started', { source_medium: 'portfolio_viewer' });
              this.current_user.status = 'member';
              deferred.resolve();
              $el.modal('hide');
            }
          };

          let vm = new LoginModal(args);
          ko.cleanNode($el[0]);
          ko.applyBindingsWithValidation(vm, $el[0], _.extend({}, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS, {insertMessages: false}));

          $el.on('shown.bs.modal', function(){
            vm.initSSOEvents();
          });
          $el.modal('show');
        } else {
          deferred.resolve();
        }
        return deferred;
      },
      like() {
        this.loginOrRegister().done(() => {
          let params = {
            voteable_id: this.comment_thread.id,
            voteable_type: 'ThreadComment'
          };
          let request = new Kadenze.AjaxRequest({
            url: Kadenze.Routes.favorite_path(), //TODO: Move this in JSON?
            data: { thread_vote: params }
          });

          if (!this.comment_thread.favorited) {
            this.comment_thread.favorite_count += 1;
            this.comment_thread.favorited = true;
          } else {
            this.comment_thread.favorite_count -= 1;
            this.comment_thread.favorited = false;
          }
        });
      },
      reply() {
        this.loginOrRegister().done(() => {
          this.show_replies = true;
          this.replying = true;
        });
      },
      edit() {
        this.loginOrRegister().done(() => {
          this.editing = true
        });
      },
      create(content) {
        let params = {
          content: content,
          commentable_id: this.comment_thread.id,
          commentable_type: 'ThreadComment'
        };
        let request = new Kadenze.AjaxRequest({
          url: this.comments_path,
          data: { thread_comment: params }
        });

        request.done((response) => {
          this.comment_thread.thread_comments.push(JSON.parse(response.thread_comment))
          this.replying = false
        });

        request.fail((xhr, status, msg) => {
          new Kadenze.Notice.error({ message: xhr.responseJSON.message });
        });
      },
      update(content) {
        let params = {
          content: content
        };
        let request = new Kadenze.AjaxRequest({
          type: 'PUT',
          url: `${this.comments_path}/${this.comment_thread.id}`,
          data: { thread_comment: params }
        });

        request.done((response) => {
          this.comment_thread.content = content;
          this.editing = false
        });

        request.fail((xhr, status, msg) => {
          new Kadenze.Notice.error({ message: xhr.responseJSON.message });
        });
      },
      remove() {
        let params = {
          deleted: true
        };
        let request = new Kadenze.AjaxRequest({
          type: 'PUT',
          url: `${this.comments_path}/${this.comment_thread.id}`,
          data: { thread_comment: params }
        });

        request.done((response) => {
          this.comment_thread.deleted = true;
          this.editing = false;
          this.$emit('removed')
        });

        request.fail((xhr, status, msg) => {
          new Kadenze.Notice.error({ message: xhr.responseJSON.message });
        });
      },
      toggleReplies() {
        this.show_replies = !this.show_replies;
        if (!this.show_replies) {
          this.replying = false
        }
      },
      userInfoTooltipParams(user) {
        return {
          template: 'templates/tooltip-userinfo',
          templateParams: {
            full_name: user.full_name,
            username: user.slug,
            avatar: user.avatar,
            profile_path: user.profile_path,
            message_path: user.message_path
          },
          position: 'top',
          showDelay: .7
        };
      }
    }
  }
</script>